const customStyles = {
  control: (styles) => ({ ...styles, minHeight: 42 }),
};

export default customStyles;
